import { Button, Stack } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'

import AuthenticationPageTemplate from '../../templates/AuthenticationPageTemplate'
import EnterNewPassword from '../../components/auth/EnterNewPassword'
import RequestNewPassword from '../../components/auth/RequestNewPassword'
import { useState } from 'react'

const ResetPassword = () => {
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const email = searchParams.get('email')

  const [resetRequestEmail, setResetRequestEmail] = useState('')
  const [alert, setAlert] = useState(null)

  return (
    <AuthenticationPageTemplate
      showLogo={true}
      alert={alert}
      title="Reset password"
      instructions={
        token && email ? (
          <>
            The password for <b>{email}</b> will be reset.
          </>
        ) : resetRequestEmail ? (
          <>
            The reset link will be sent to <b>{resetRequestEmail}</b>. It might
            take a few minutes for the email to arrive.
          </>
        ) : (
          <>
            Enter your email address where you will get the instructions to
            reset your password.
          </>
        )
      }
      onBackNavigation={() => navigate('/login')}
    >
      {
        <Stack
          sx={{
            gap: 4,
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          {token && email ? (
            <EnterNewPassword
              token={token}
              email={email}
              setAlert={setAlert}
            ></EnterNewPassword>
          ) : resetRequestEmail ? (
            <Button
              id="verify-button"
              variant="outlined"
              color="primary"
              onClick={() => navigate('/login')}
            >
              Back to Sign In
            </Button>
          ) : (
            <RequestNewPassword
              updateEmail={setResetRequestEmail}
              setAlert={setAlert}
            ></RequestNewPassword>
          )}
        </Stack>
      }
    </AuthenticationPageTemplate>
  )
}

export default ResetPassword
